import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitBtn"];

  connect() {
    this.element.querySelectorAll("textarea").forEach((ta) => this.#resize(ta));
  }

  inputChanged(event) {
    const group = event.target.closest("[data-question-id]");
    const textarea = group.querySelector("textarea");
    if (textarea) {
      textarea.value = "";
      this.#resize(textarea);
    }
    this.#updateSubmitBtn();
  }

  freeTextInput(event) {
    const textarea = event.currentTarget;
    const group = textarea.closest("[data-question-id]");

    group.querySelectorAll("input[type='radio'], input[type='checkbox']").forEach((r) => {
      if (r.dataset.other === undefined) r.checked = false;
    });

    const otherRadio = group.querySelector("input[data-other]");
    if (otherRadio) otherRadio.checked = textarea.value.trim().length > 0;

    this.#resize(textarea);
    this.#updateSubmitBtn();
  }

  #resize(textarea) {
    textarea.style.height = "0";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  #updateSubmitBtn() {
    const groups = this.element.querySelectorAll("[data-question-id]");
    const allAnswered = Array.from(groups).every((group) => {
      if (group.querySelector("input:checked")) {
        const otherRadio = group.querySelector("input[data-other]");
        if (otherRadio?.checked) {
          const textarea = group.querySelector("textarea");
          return textarea && textarea.value.trim() !== "";
        }
        return true;
      }
      const textarea = group.querySelector("textarea");
      return textarea && textarea.value.trim() !== "";
    });
    this.submitBtnTarget.disabled = !allAnswered;
  }
}
